import React from 'react'
import Link from 'gatsby-link'

import './style/sitemap.css'

const sections = [
  {
    name: 'Why Lease',
    path: 'why',
    subsections: ['good-business', 'lease-loan', 'case-study', 'questions', 'history', 'press']
  },
  {
    name: 'Services',
    path: 'services',
    subsections: ['consulting', 'brokering', 'vendor']
  },
  {
    name: 'Experience',
    path: 'experience',
    subsections: ['memberships', 'testimonials']
  },
  {
    name: 'Contact',
    path: 'contact'
  },
  {
    name: 'Links',
    path: 'links'
  }
]

export default () => (
  <div className='sitemap'>
    <div className='sitemap-hero'>
      <div className='sitemap-hero-img' />
    </div>
    <div className='sitemap-title'>
      Sitemap
    </div>
    <div className='sections-wrap'>
      {sections.map((section, i) => {
        return (
          <div className='section' key={i}>
            <Link className={`section-link${section.subsections ? '' : ' no-subsections'}`} to={`/${section.path}`}>
              {section.name}
            </Link>
            {section.subsections ? (
              <div className='subsections-wrap'>
                {section.subsections.map((subsection, i) => {
                  let formatted = subsection.includes('-') ? subsection.replace('-', ' ') : subsection
                  if (subsection === 'lease-loan') formatted = 'Lease vs Loan'
                  return (
                    <Link className='subsection-link' style={subsection === 'lease-loan' ? {textTransform: 'none'} : {}} key={i} to={`${section.path}/${subsection}`}>
                      {formatted}
                    </Link>
                  )
                })}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/sitemap.js